export default {
    status_no: '404',
    name: 'Nije pronađeno',
    message: 'Stranica nije pronađena',
}
